// @flow

import * as React from 'react';
import { DatePicker } from 'recal';
import {event} from "../../Helpers/ga";
import {APP_NAME} from "../App";

type Props = {|
  start: number,
  end: number,
  changeDate: Date => any,
  current: Date,
  month?: number,
  year?: number,
  onMonthChange?: Function,
|};

type CalendarType = 'Small' | 'Large';

function trackDateChange(from: Date, to: Date, calenderType: CalendarType): void {
  let [year, month, date] = [from.getFullYear(), from.getMonth() + 1, from.getDate()];
  let [tYear, tMonth, tDate] = [to.getFullYear(), to.getMonth() + 1, to.getDate()];

  event(
    APP_NAME,
    `Calendar ${calenderType} | Select Date`,
    `${year}-${month}-${date} | ${tYear}-${tMonth}-${tDate}`
  );
}

export default class Calendar extends React.Component<Props> {
  onDateSelected(d: Date) {
    let {
      current,
      changeDate
    } = this.props;

    trackDateChange(current, d, 'Small');
    changeDate(d);
  }

  render() {
    let { start, end, current, month, year, onMonthChange } = this.props;

    return <div id="small-calendar" tabIndex="-1">
      <DatePicker
        onDateSelected={this.onDateSelected.bind(this)}
        date={current}
        isDateEnabled={d => d.getTime() / 1000 > start && d.getTime() / 1000 < end}
        month={month + 1} // Expects standard months, not JS months
        year={year}
        // Convert back to JS months
        onMonthChange={(nextMonth, nextYear) => onMonthChange && onMonthChange(nextMonth - 1, nextYear)}
        disableKeyboard={true}
      />
    </div>;
  }
}

export class LargeCalendar extends React.Component<Props> {
  onDateSelected(d: Date) {
    let {
      current,
      changeDate
    } = this.props;

    trackDateChange(current, d, 'Large');
    changeDate(d);
  }

  render() {
    let { start, end, current, month, year, onMonthChange } = this.props;

    return <div id="large-calendar" tabIndex="-1">
      <DatePicker
        onDateSelected={this.onDateSelected.bind(this)}
        date={current}
        isDateEnabled={d => d.getTime() / 1000 > start && d.getTime() / 1000 < end}
        month={month + 1} // Expects standard months, not JS months
        year={year}
        // Convert back to JS months
        onMonthChange={(nextMonth, nextYear) => onMonthChange && onMonthChange(nextMonth - 1, nextYear)}
        disableKeyboard={true}
      />
    </div>
  }
}